import {AttributeType} from '@netx/core-attribute/constants';

export const ATTRIBUTE_VOCABULARY_TYPES: readonly AttributeType[] = [
	AttributeType.SELECT,
	AttributeType.TAG,
];

export const ATTRIBUTE_VOCABULARY_PAGE_SIZE = 25;

export const ATTRIBUTE_VOCABULARY_UPLOAD_FILE_FORMATS = ['text/csv'];
